import { Plus } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const AddIcon = createLucideIcon(Plus);
